// Bono Cambios de Aceite — % a descontar de la bolsa mensual según qué tan a
// tiempo se hicieron los cambios de aceite. El mes lo decide services.created_at
// (fecha de registro en el sistema), no performed_at, para que no se pueda
// "acomodar" un servicio en otro mes. Odómetro requerido = odómetro del cambio
// anterior (0 si no hay) + intervalo del tipo de servicio (10,000 km).
//   Realizado:    >1,500 km antes → 15% | -1,500..+1,500 → 0% | +1,501..+3,000 → 5% | +3,001 → 10%
//   No realizado: vencido al cierre del mes (u hoy, si es el mes en curso) → ≤3,000 → 0% | +3,000 → 15%
// Los descuentos se suman; el total se topa en 100%.
import moment from "moment";
import supabase from "../../../supabase-client";
import { formatFriendlyDate } from "../../../utility/funcs";

const pct = (v) => `${(Number(v) * 100).toFixed(0)}%`;
const capped = (v) => Math.min(Number(v) || 0, 1);
const fmtKm = (v) => (v === null || v === undefined ? "" : Number(v).toLocaleString("es-MX"));
const fmtDelta = (v) =>
  v === null || v === undefined ? "" : `${Number(v) > 0 ? "+" : ""}${Number(v).toLocaleString("es-MX")}`;
const fmtDate = (v) => (v ? formatFriendlyDate(v) : "");

const STATUS_LABELS = {
  paid: "Pagado",
  payment_pending: "Pago pendiente",
  pending_approval: "Por aprobar",
};

const RESULT_ORDER = [
  "Vencido +3,000 km",
  "Anticipado (+1,500 km antes)",
  "Tarde +3,000 km",
  "Tarde 1,501–3,000 km",
  "Vencido ≤3,000 km",
  "A tiempo",
];

export const oilChangeBonusReport = {
  id: "oil-change-bonus",
  title: "Bono Cambios de Aceite",
  description: "Porcentaje a descontar de la bolsa mensual según la puntualidad de los cambios de aceite.",
  category: "Operaciones",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Mes", required: true },
    { type: "facet", key: "row_type", label: "Tipo", column: "row_type" },
    { type: "facet", key: "result", label: "Resultado", column: "result", order: RESULT_ORDER },
    { type: "facet", key: "created_by", label: "Registró", column: "created_by" },
  ],
  summary: [
    { type: "sum", label: "Descuento Total (tope 100%)", valueKey: "deduction_pct", valueFormat: (v) => pct(capped(v)) },
    { type: "sum", label: "Bono a Pagar", valueKey: "deduction_pct", valueFormat: (v) => pct(1 - capped(v)) },
    { type: "count", label: "Casos" },
    { type: "groupBy", label: "Resultado", key: "result" },
  ],
  columns: [
    { key: "row_type", label: "Tipo" },
    { key: "result", label: "Resultado", width: 200 },
    { key: "deduction_pct", label: "Descuento", format: pct, exportType: "percent" },
    { key: "plate", label: "Placa" },
    { key: "model", label: "Modelo", width: 200, truncate: true },
    { key: "segment", label: "Segmento" },
    { key: "service_id", label: "Servicio" },
    { key: "created_at", label: "Registrado", format: fmtDate, exportType: "date" },
    { key: "performed_at", label: "Realizado", format: fmtDate, exportType: "date" },
    { key: "created_by", label: "Registró" },
    { key: "status", label: "Estatus", format: (v) => STATUS_LABELS[v] || v || "" },
    { key: "prev_odometer", label: "Odóm. Cambio Anterior", format: fmtKm, exportType: "integer" },
    { key: "required_odometer", label: "Odóm. Requerido", format: fmtKm, exportType: "integer" },
    { key: "odometer", label: "Odóm. Servicio / Cierre", format: fmtKm, exportType: "integer" },
    { key: "km_delta", label: "Diferencia km", format: fmtDelta, exportType: "integer" },
    { key: "system_odometer", label: "Odóm. Sistema (GPS)", format: fmtKm, exportType: "integer" },
  ],
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar mes");
    const start = moment(from, "YYYY-MM-DD");
    const end = moment(to, "YYYY-MM-DD");
    if (start.date() !== 1 || !end.isSame(start.clone().endOf("month"), "day")) {
      throw new Error("Este reporte es mensual: elige un mes completo (p. ej. “Mes pasado”).");
    }
    const { data, error } = await supabase.rpc("report_oil_change_bonus", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
